// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q2/2023draw_idea/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const token =
  'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vZGV2YXBpLmNxY2IuY29tL2FwaS91c2VyL2xvZ2luIiwiaWF0IjoxNjMxMTU1MTU4LCJleHAiOjE2MzExNTUyMTgsIm5iZiI6MTYzMTE1NTE1OCwianRpIjoidTFRMEJBam5GMDl2a1p1VSIsInN1YiI6ODc1MzYzLCJwcnYiOiI4NjY1YWU5Nzc1Y2YyNmY2YjhlNDk2Zjg2ZmE1MzZkNjhkZDcxODE4In0.droYDhfvZ6y2UZ-w8x_WscBeFqeY5C3WQGFcC69Lv5E';
// 获取列表
const getList = (page: number, keyword?: string, workType?: number) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      search: keyword,
      workType,
    },
  });
};
// 规则
export const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

// 提交
export const save = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData, { headers: {} });
};

// 详情
export const detail = (id: any) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};
// 获取列表
export const getUserList = (page: number, unionid?: any) => {
  return http.get(`${urlPrefix}vote-list-user`, {
    params: {
      page,
      unionid,
    },
    headers: {},
  });
};
export { getBaseInfo, getList };
